import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-general-half-star-icon',
  templateUrl: './general-half-star.component.html'
})
export class GeneralHalfStarComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
